
export const User = (userData) => {
    return {
        getUserName: () => {
            return userData.attributes.name
        },
        getIdentification: () => {
            return userData.attributes["custom:identificacion"]
        },
        getTel1: () => {
            return (userData.attributes["custom:tel_mobile"] || "").replaceAll("+506", "");
        },
        getTel2: () => {
            return (userData.attributes["custom:tel_home"] || "").replaceAll("+506", "");
        },
        getEmail: () => {
            return userData.attributes["email"]
        },
        getTipoIdentification: () => {
            return (userData.attributes["custom:tipo_identificacion"] || "");
        },
        getAddress: () => {
            return (userData.attributes["custom:tipo_identificacion"] || "");
        },
        getEinvoiceType: () => {
            return (userData.attributes["custom:e_invoice_active"] || "") === 1 ? "0" : "1";
        },

    }

}